<template>
    <div class="empty-box">
        <img src="../assets/images/null_tips.png" style="max-width: 300px;"/>
        <p>没有找到您要的结果</p>
    </div>
</template>

<script lang="ts">
import { defineComponent} from 'vue'
export default defineComponent({
  name: 'SearchBanner',
  components: {
  },
  setup() {
    return {
 
    }
  },
})
</script>

<style lang="scss">
 .empty-box {
   text-align: center;
   p {
     margin-top: -30px;
   }
 }
</style>